import { EntityRatingCommentCount, Rating, Partner } from '@medprev-web-app/api-graphql-client';
import { ReactNode } from 'react';

import PartnerShowAddress from './partner-show-address.component';

import { EntityProfileActions } from '@/app/(main)/(pages)/_components/entities/entity-profile-actions.component';
import { EntityRating } from '@/app/(main)/(pages)/_components/entities/entity-rating-sumary.component';
import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface PartnerHeaderProps {
  partner: Partner;
  commentsCount?: EntityRatingCommentCount | null;
  scheduleAction?: ReactNode;
}

export function PartnerHeader({ partner, commentsCount, scheduleAction }: PartnerHeaderProps) {
  const formatAddress = (): string | undefined => {
    if (!partner.facilities?.length) {
      return;
    }

    const facility = partner.facilities[0];

    return `${facility?.neighborhood ? `${facility?.neighborhood} • ` : ''} ${facility?.city} - ${facility?.state}`;
  };

  const resolvePartnerName = (): string => {
    if (partner.socialName) {
      return formatToTitleCase(partner.socialName);
    }

    return formatToTitleCase(partner.legalName as string);
  };
  const partnerName = resolvePartnerName();

  return (
    <>
      <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
        <EntityAvatar
          src={partner.avatar}
          size="4xl"
          alt={`Foto de perfil de ${partnerName}`}
          type={EntityTypeEnum.CLINIC}
          shouldAddLightbox
          priority
          data-analytics-event={AnalyticsEnum.CLICK_PARTNER_AVATAR}
        />

        <div>
          <div className="max-w-xs sm:max-w-[400px] m-auto md:m-0">
            <Typography
              variant={TypographyVariant.MODAL_TITLE}
              className="text-center md:text-left break-words text-wrap hyphens-auto overflow-hidden"
            >
              {partnerName}
            </Typography>
          </div>

          <ol className="flex flex-col items-center md:items-start mt-2">
            <li className="text-gray-700 text-sm flex flex-col items-center md:items-start justify-center">
              <span className="flex items-center gap-1">{formatAddress()}</span>
              <PartnerShowAddress data-analytics-event={AnalyticsEnum.CLICK_PARTNER_ADDRESS} />
            </li>
          </ol>
        </div>
      </div>
      <div className="mt-5">
        <EntityRating
          rating={partner?.facilities[0]?.rating as Rating}
          commentsCount={commentsCount}
          data-analytics-event={AnalyticsEnum.CLICK_PARTNER_REVIEW}
        />
      </div>

      <div className="mt-5 md:mt-3">
        <EntityProfileActions
          entityType={EntityTypeEnum.CLINIC}
          entity={partner}
          scheduleAction={scheduleAction}
        />
      </div>
    </>
  );
}
